<template>
  <div class="homslider-cls">
    <div class="hm-slider-responsive" v-if="is_scrren_hide">
      <home-nav-bar
        @isDelivery="isHomeDeliverySet"
        @getLatLong="onMobileLocationClick"
      ></home-nav-bar>
    </div>
    <div class="home-slider-main myhome-slider">
      <VueSlickCarousel
        v-if="banners && banners.length > 0 && $auth.setting"
        v-bind="settings"
        class="round-arrow"
      >
        <div
          v-for="(banner, index) in banners"
          :key="index"
          class="vue-slide-carousel"
        >
          <a
            v-if="banner.type === 'link'"
            :href="banner.link.includes('http') ? banner.link : '//' + banner.link"
            target="_blank"
          >
            <div class="testimonial-item newBannerLayout">
              <img :src="banner.image" />
            </div>
          </a>
          <div
            v-else-if="banner.type === 'brand'"
            href="#"
            target="_blank"
            @click="brandBannerClicked(banner)"
          >
            <div class="testimonial-item newBannerLayout">
              <img :src="banner.image" />
            </div>
          </div>
          <div
            v-else-if="banner.type === 'noaction'"
            class="testimonial-item newBannerLayout"
          >
            <img :src="banner.image" />
          </div>
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import HomeNavBar from "@/components/HomeNavBar.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  props: ["banners"],
  components: { HomeNavBar, VueSlickCarousel },
  data() {
    return {
      is_scrren_hide: window.screen.width < 1024,
      settings: {
        autoplay: true,
        focusOnSelect: true,
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              initialSlide: 4
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    };
  },
  methods: {
    isHomeDeliverySet(value) {
      this.$emit("isDeliveryHome", value);
      this.$store.commit("order/pickupdelivery", value);
    },
    onMobileLocationClick(value) {
      this.$emit("getMobileLatLong", value);
    },
    brandBannerClicked(banner){
      if(banner.brand_id) {
        this.$emit('brand-banner-clicked', banner.brand_id);
      }
    }
  }
};
</script>

<style>
.newBannerLayout {
  margin: 10px 20px 20px 0 !important;
}
.myhome-slider .testimonial-item.newBannerLayout img {
  height: 250px;
}
</style>